import getTableColumnCountForCells from '../utils/getTableColumnCountForCells';
export default function getCellAbove(editor) {
  var activeCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : editor.value.startBlock;
  if (!activeCell) return;
  var tableId = editor.getCurrentTableId(activeCell);

  if (!tableId) {
    var previousBlock = editor.value.document.getPreviousBlock(activeCell.key);
    if (!previousBlock) return;
    tableId = previousBlock.getIn(['data', 'tableId']);
  }

  var cells = editor.getTableCells(tableId);
  var columnCount = getTableColumnCountForCells(cells);
  var activeCellIndex = cells.findIndex(function (cell) {
    return cell === activeCell;
  });

  if (!cells.isEmpty() && activeCellIndex === -1) {
    return cells.get(cells.size - columnCount);
  } else if (activeCellIndex - columnCount >= 0) {
    return cells.get(activeCellIndex - columnCount);
  }
}